export enum MetadataCheckStatus {
  ACCEPTED = 'accepted',
  FAILED = 'failed',
}
